const URL_PATTERN = /(?:https?:\/\/|www\.)\S+/i;
const URL_PATTERN_GLOBAL = /(?:https?:\/\/|www\.)\S+/gi;

export const containsURL = (text: string): boolean => {
  if (!text) {
    return false;
  }

  return URL_PATTERN.test(text);
};

export const sanitizeText = (text: string): string => {
  if (!text) {
    return text;
  }

  return text.replace(URL_PATTERN_GLOBAL, '').replace(/\s+/g, ' ').trim();
};
